import BaseComponent from "common/Components/BaseComponent";
import { useEffect, lazy, Suspense, useState } from "react";
import { useGroupsViewInitialization } from "./Groups.hook";
import { useNavigate } from "react-router-dom";
import { clearCustomerContextHeaders } from "common/HttpClient/CustomerContextHeaders";
import GROUPS_CONSTANTS from "./GroupsConstant";
import { createCustomerStyles, sharedGroupsCSS } from "./CreateCustomer.style";
const CreateGroup = lazy(() => import("./Components/CreateGroup"));
const Loading = lazy(() => import("common/Components/Loading"));
const Toast = lazy(() => import("common/Components/Toast"));

const CreateCustomer = () => {
  const { state, actions } = useGroupsViewInitialization();
  const [toast, setToast] = useState({
    show: false,
    type: GROUPS_CONSTANTS.toast.TYPE_SUCCESS,
    title: "",
    description: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const styleId = "shared-groups-component-styles";
    let styleElement = document.getElementById(styleId);

    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = styleId;
      styleElement.textContent = sharedGroupsCSS;
      document.head.appendChild(styleElement);
    }
  }, []);

  useEffect(() => {
    const selectedCustomer = localStorage.getItem("selected_customer");
    if (selectedCustomer) {
      localStorage.removeItem("selected_customer");
    }
    clearCustomerContextHeaders();
    if (state.groups === null) {
      actions.getAllGroups();
    }
  }, []);

  const handleCancel = () => {
    navigate("/");
  };

  const handleAddGroupAction = (groupInfo, onSuccessCallback) => {
    actions.addNewGroup(groupInfo, (newGroup) => {
      setToast({
        show: true,
        type: GROUPS_CONSTANTS.toast.TYPE_SUCCESS,
        title: GROUPS_CONSTANTS.toast.TITLE_SUCCESS,
        description: GROUPS_CONSTANTS.alert.CUSTOMER_CREATED_SUCCESS,
      });
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    });
  };

  useEffect(() => {
    if (state.error) {
      setToast({
        show: true,
        type: GROUPS_CONSTANTS.toast.TYPE_FAILURE,
        title: GROUPS_CONSTANTS.toast.TITLE_FAILED,
        description: state.error,
      });
    }
  }, [state.error]);

  const handleToastClose = () => {
    setToast((prev) => ({ ...prev, show: false }));
    if (state.error) {
      actions.refreshError();
    }
  };

  const isInitialLoad = state.loading && state.groups === null;

  return (
    <BaseComponent>
      <Suspense fallback={null}>
        <Toast
          type={toast.type}
          title={toast.title}
          description={toast.description}
          show={toast.show}
          onClose={handleToastClose}
          duration={GROUPS_CONSTANTS.toast.DURATION}
        />
      </Suspense>
      {state.loading && (
        <div style={createCustomerStyles.loadingContainer(isInitialLoad)}>
          <Suspense fallback={<div>{GROUPS_CONSTANTS.loading.FALLBACK}</div>}>
            <Loading />
          </Suspense>
        </div>
      )}
      {!isInitialLoad && (
      <div style={createCustomerStyles.mainContainer}>
        <div style={createCustomerStyles.breadcrumbContainer}>
          <ol className="breadcrumb breadcrum-margin" style={createCustomerStyles.breadcrumbItem}>
            <li className="breadcrumb-item">
              <button
                className="breadcrumb-item-custom breadcrumb-title-font-style btn-breadcrum"
                onClick={handleCancel}
                style={createCustomerStyles.breadcrumbButton}
              >
                {GROUPS_CONSTANTS.breadcrumb.CUSTOMER_OVERVIEW}
              </button>
            </li>
            <li
              className="breadcrumb-item breadcrumb-title-font-style active"
              aria-current="page"
            >
              {GROUPS_CONSTANTS.breadcrumb.CREATE_CUSTOMER}
            </li>
          </ol>
        </div>
        <div
          className="add-cust-form"
          style={createCustomerStyles.formContainer}
        >
          <div className="col-12 row " style={createCustomerStyles.formRow}>
            <Suspense fallback={<span>{GROUPS_CONSTANTS.loading.FALLBACK}</span>}>
              <CreateGroup
                handleAddGroupAction={handleAddGroupAction}
                handleCancel={handleCancel}
                groups={state.groups || []}
              />
            </Suspense>
          </div>
        </div>
      </div>
      )}
    </BaseComponent>
  );
};

export default CreateCustomer;
